import React, { useState, useContext } from 'react';
import classes from './index.module.scss';
import { Container, Row, Col } from 'react-bootstrap';
import TextInput from '../UI/TextInput';
import Select from '../UI/Select';
import TextArea from '../UI/TextArea';
import { useForm } from "react-hook-form";
import { contactUsPost } from '../../api';
import Loading from '../Loading';
import { UserContext } from '../../context/User';


const ContactUs = () => {

  const { isLoggedIn, user } = useContext(UserContext);

  const [inputValues, setInputValues] = useState({
    name: "",
    email: "",
    subject: "Login Failure",
    body: ""
  });
  const { register, handleSubmit, errors } = useForm();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const chooseCategoryHandler = selectedOption => {
    setInputValues({
      ...inputValues,
      subject: selectedOption.value
    })
  }

  const onSubmit = (data, e) => {
    e.preventDefault();
    e.target.reset();

    setLoading(true);
    const params = {
      ...inputValues,
      ...data
    }

    contactUsPost(params)
      .then(response => {
        setSuccess(true)
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      })
  }

  return (
    <div className={classes.Contact_Us}>
      <Container>
        <Row>
          <Col lg={{ offset: 3, span: 6 }}>
            <h2 className={classes.Contact_Us_Title}>
              Contact Us
            </h2>
            <form onSubmit={handleSubmit(onSubmit)}>
              <fieldset>
                <label htmlFor="name">Name</label>
                <TextInput
                  name="name"
                  type="text"
                  placeholder="Name"
                  register={register({ required: true })}
                  value={user && user.username}
                />
                {errors.name && <p className="warnMessage">Name is required</p>}
              </fieldset>
              <fieldset>
                <label htmlFor="email">Email</label>
                <TextInput
                  name="email"
                  type="email"
                  placeholder="Email"
                  register={register({ required: true })}
                  value={user && user.email}
                />
                {errors.email && <p className="warnMessage">Email is required</p>}
              </fieldset>
              <fieldset>
                <label htmlFor="category">Category</label>
                <Select
                  name="category"
                  isSearchable={false}
                  placeholder="Category"
                  defaultValue={{ value: "Login Failure", label: "Login Failure" }}
                  isClear={false}
                  list={[
                    { value: "Login Failure", label: "Login Failure" },
                    { value: "Website Feedback", label: "Website Feedback" },
                    { value: "Information Request", label: "Information Request" },
                    { value: "Products", label: "Products" },
                    { value: "Consulting", label: "Consulting" },
                    { value: "Advertising", label: "Advertising" },
                    { value: "Training", label: "Training" },
                    { value: "Other", label: "Other" }
                  ]}
                  handleMultiChange={chooseCategoryHandler}
                  styles="react-select-input-container"
                  prefixStyles="react-select-input"
                />
              </fieldset>
              <fieldset>
                <label htmlFor="message">Message</label>
                <TextArea
                  name="body"
                  placeholder="Message"
                  register={register()}
                />
              </fieldset>
              {success && <p className="text-center mb-4">Thank you, your message has been sent.</p>}
              <button
                type="submit"
                className="filledBtn btnSizes w-100 py-3"
              >
                Send
              </button>
            </form>
          </Col>
        </Row>
      </Container>
      {loading && <Loading />}
    </div>
  )
}

export default ContactUs;
